export enum SourcesNames {
    MANUAL_MODELISATION = "Modélisation manuelle",
    BUNDLE_CREATION = "BUNDLE_CREATION",
    INIES = "Inies",
    NOOCO = "Nooco",
    ECO_INVENT = "Ecoinvent",
    ADEME = "Ademe",
    IBU = "IBU",
    ECOPASSPORT = "ECOPASSPORT",
    ENVIRONDEC='Environdec'
  }
